import logger from "@/shared/utils/logger";
import Script from "next/script";

export default function GoogleAnalytics({ gaId }: { gaId: string }) {
  return (
    <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gaId}', {
              send_page_view: true,
              debug_mode: false
            });
          `,
        }}
      />
    </>
  );
}

export const GtagEvent = (
  action: string,
  value: unknown,
) => {
  if (typeof window === 'undefined') return;

  try {
    // @ts-expect-error - window.gtag is a global function injected by Google Analytics
    window.gtag('event', action, value);
  } catch (error) {
    logger.error('GtagEvent', error);
  }
};